class GravityFormDoiChange {
	constructor() {
		this.init();
	}

	init() {

        const obj = this;

        // button added within gravity form to check associated url field value for doi
        $("body").on( "click", "#doi-verify-button", function(e) {
            e.preventDefault();
            if($(this).prop('disabled')){
                return;
            }
            // get the button html
            const buttonHtml = $(this).html();

            const doiDomain = 'https://doi.org/';

            // clear any prior feedback
            $('#doi-feedback').html('');
            
            // identify the url input fields
            const doiUrlInput = $(this).parents('form:first').find('.doi_url:first input[type=text]:first');
            const doiUrlInputConfirmed = $(this).parents('form:first').find('.doi_url_confirmed:first input[type=text]:first');

            if(!doiUrlInput.length){
                return;
            }

            // Sanity check domain is not included
            doiUrlInput.val(doiUrlInput.val().replace(doiDomain,'').trim());

            // clear confirmed input (will hide form fields)
            doiUrlInputConfirmed.val('').trigger('change');;

            // url to test
            const doiUrl = doiDomain + doiUrlInput.val();
            const expression = /https?:\/\/(dx\.)?doi\.org\/10\.\d{4,9}\/[-._;()\/:A-Z0-9]+/i;
            const regex = new RegExp(expression);
            
            if (!doiUrl.match(regex)) {
              $('#doi-feedback').html('<span style="color:red">Invalid url. Please try again.</span>');
              return;
            }

            // disable button / show spinner
            $(this).prop("disabled",true).html('<img id="td-spinner" src="' + tdI18n.spinner + '" alt="waiting" aria-hidden="true" style="display:inline-block;margin-top:5px;margin-left:5px;" />');


            fetch('/wp-json/api/pkrxiv-check-doi-url', {
                method: 'POST',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({doiUrl: doiUrl})
              })

              .then(response => response.json())
              .then(content => {
                $(this).html(buttonHtml);
                     $(this).prop('disabled',false);
    
    
                     if(content.error){
                         $('#doi-feedback').html('<span style="color:red">'+content.error+'</span>');
                         doiUrlInputConfirmed.val('').trigger('change');
                         return;                    
                     }
    
                     doiUrlInputConfirmed.val(doiUrl).trigger('change');
                     obj.prefillForm(content);
                     $('#doi-feedback').html('');
            });
        });
	}

    prefillForm(content) {

        // Authors
        let doiAuthorsCount = 0;
        const listItemAddButton = $('.gfield.doi_authors').find('.add_list_item:first');
        const listItemRemoveButtons = $('.gfield.doi_authors').find('.delete_list_item');
        const listItemRemoveButton = $('.gfield.doi_authors').find('.delete_list_item:first');

        if(listItemRemoveButtons.length && listItemRemoveButton){
            // remove any previous author list items
            $(listItemRemoveButtons).not(listItemRemoveButton).each(function(){
                $(this).trigger("click");
            })
        }

        if(typeof content.response['author'] != 'undefined' && listItemAddButton.length){

            doiAuthorsCount = content.response['author'].length;

            // need to have correct number of author list items
            for(let i = 1; i < doiAuthorsCount; i++) {
               $(listItemAddButton).trigger("click");
            }

            // now populate each list item accordingly
            content.response.author.forEach((entry,index) => {

                let authorInput = $('.gfield.doi_authors').find('.gform-grid-row').eq(index+1).find('.gfield_list_cell[data-label=Author]:first input:first');
                let affiliationInput = $('.gfield.doi_authors').find('.gform-grid-row').eq(index +1).find('.gfield_list_cell[data-label=Affiliation]:first input:first');
                let countryInput = $('.gfield.doi_authors').find('.gform-grid-row').eq(index +2).find('.gfield_list_cell[data-label="Country of Institution"]:first select:first');

                let affiliations = entry.affiliation.reduce((detail,currentAff)=>{
                    detail += currentAff.name + ', ';
                    return detail;
                },'');

                affiliations = affiliations === '' ? 'N/A' : affiliations;
                authorInput.val(entry.given + ' ' + entry.family);
                affiliationInput.val(affiliations);
                // these values are not specified by the api, so manually defaulting to "" (Please Select)
                countryInput.val('');
            });
        }else{
            // no authors detected
            let authorInput = $('.gfield.doi_authors').find('.gform-grid-row').eq(1).find('.gfield_list_cell[data-label=Author]:first input:first');
            let affiliationInput = $('.gfield.doi_authors').find('.gform-grid-row').eq(1).find('.gfield_list_cell[data-label=Affiliation]:first input:first');
            let countryInput = $('.gfield.doi_authors').find('.gform-grid-row').eq(2).find('.gfield_list_cell[data-label="Country of Institution"]:first input:first');
            authorInput.val('N/A');
            affiliationInput.val('N/A');
            countryInput.val('N/A');
        }

        // Title
        let doiTitle = 'N/A';
        if(typeof content.response.title != 'undefined' && content.response.title != ''){
            doiTitle = content.response.title;
        }
        $('.gfield.doi_article_title').find('input:first').val(doiTitle);

        // Journal Name
        let doiJournalName = 'N/A';
        if(typeof content.response['container-title'] != 'undefined' && content.response['container-title'] != ''){
            doiJournalName = content.response['container-title'];
        }
        $('.gfield.doi_journal_name').find('input:first').val(doiJournalName);

        // Journal Volume
        let doiJournalVolume = 'N/A';
        if(typeof content.response.volume != 'undefined' && content.response.volume != ''){
            doiJournalVolume = content.response.volume;
        }
        $('.gfield.doi_journal_volume').find('input:first').val(doiJournalVolume);

        // Journal Issue
        let doiJournalIssue = 'N/A';
        if(typeof content.response.issue != 'undefined' && content.response.issue != ''){
            doiJournalIssue = content.response.issue;
        }
        $('.gfield.doi_journal_issue').find('input:first').val(doiJournalIssue);

        // Journal Page
        let doiJournalPage = 'N/A';
        if(typeof content.response.page != 'undefined' && content.response.page != ''){
            doiJournalPage = content.response.page;
        }
        $('.gfield.doi_journal_page').find('input:first').val(doiJournalPage);

        // Doi year
        let doiYear = 'N/A';
        if(typeof content.response['published-print'] != 'undefined'){
            doiYear = content.response['published-print']['date-parts'][0][0] ?? 'N/A';
        }else{
            if(typeof content.response['published-online'] != 'undefined'){
                doiYear = content.response['published-online']['date-parts'][0][0] ?? 'N/A';
            }
        }
        $('.gfield.doi_year').find('input:first').val(doiYear);

        // Preferred Date
        $('.gfield.preferred_publish_date').find('input:first').val( moment().format('DD/MM/YYYY HH:mm'));

        // Doi
        let doi = 'N/A';
        if(typeof content.response.DOI != 'undefined'){
            doi = content.response.DOI;
        }
        $('.gfield.doi_doi').find('input:first').val(doi);        
    }
}
export default GravityFormDoiChange;
